import { ButtonText, Col, Icon, Row } from "@visa/vds"
import { AuthenticatedExternalUserRoutes, LIBRARY_VISA_SECURE_TEST_TOOLS } from "_constants/PageRoutes";
import { useAuthContextUser } from "context/AuthContext";
import { ProductSelectionConst } from "pages/3DSStore/PurchaseProduct/Components/SelectProduct/ProductSelectionLogic";
import React from "react"
import { useHistory } from "react-router-dom";

const VsttAccordionActionItems = (props) => {
    const history = useHistory();
    const user = useAuthContextUser();
    const isSubscriptionManager = user && user.isSubscriptionManager;

    return (
        <Row className="vsts-vstt-header-row">
            <Col className="vsts-vstt-link" s={2} md={2} lg={6} xl={6}>
                <a id="vstt_introduction_linktext" onClick={() => history.push(LIBRARY_VISA_SECURE_TEST_TOOLS)} className="cursor-pointer text-decoration-none">
                    <Icon name="glossary" resolution="low" /> VSTT Introduction
                </a>
            </Col>
            <Col textAlign="right" s={3} md={3} lg={3} xl={3}>
                <ButtonText
                    id="purchase_VSTT_btn"
                    disabled={!isSubscriptionManager}
                    onClick={() => history.push({
                        pathname: AuthenticatedExternalUserRoutes.STORE_PURCHASE,
                        state: {
                            selectedProduct: ProductSelectionConst.VSTT_CATEGORY
                        }
                    })} className="width-full button-text" >Purchase VSTT Subscription</ButtonText>
            </Col>
        </Row>
    )
}

export default VsttAccordionActionItems